import { _ as __assign } from '../../chunks/bundle-BXYHgzRj.js';
import React__default from 'react';
import { useSendbirdStateContext } from '../../useSendbirdStateContext.js';
import { useChannelContext } from '../context.js';
import { g as getSuggestedReplies } from '../../chunks/bundle-CGbKAqtd.js';
import { b as isDisabledBecauseFrozen, c as isDisabledBecauseMuted } from '../../chunks/bundle-Bf00X-bc.js';
import { M as MessageView } from '../../chunks/bundle-BRQfx_hR.js';
import { FileViewer } from './FileViewer.js';
import RemoveMessageModal from './RemoveMessageModal.js';
import '../../withSendbird.js';
import '../../chunks/bundle-CfyvTsrV.js';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-Bd7J49Pj.js';
import '../../chunks/bundle-u-vzK-oc.js';
import 'react-dom';
import '../../chunks/bundle-DWyboFhb.js';
import '../../chunks/bundle-CqMQE3-R.js';
import '../../chunks/bundle-DtujCCHB.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-DNnUvjnZ.js';
import '../../ui/Icon.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '../../chunks/bundle-ClfkSu0m.js';
import '@sendbird/chat/openChannel';
import '@sendbird/chat/groupChannel';
import '../../chunks/bundle-C4eUm39A.js';
import '../../chunks/bundle-Dz4_R08c.js';
import '../../chunks/bundle-CXA05pe2.js';
import '../../chunks/bundle-CZybJwCN.js';
import '../../ui/SortByRow.js';
import '../../chunks/bundle-Cytf5OXn.js';
import '../../chunks/bundle-BKmrhRhi.js';
import '../../chunks/bundle-Bytw3a1z.js';
import '../../chunks/bundle-DokyceKk.js';
import '@sendbird/chat/message';
import '../../chunks/bundle-BqOj5e7u.js';
import '../../chunks/bundle-wIpBG4h1.js';
import '../../chunks/bundle-CXcQbCC8.js';
import '../../chunks/bundle-mZUrgg4o.js';
import '../../chunks/bundle-CeFR-WNJ.js';
import '../../chunks/bundle-CK28kSQl.js';
import '../../chunks/bundle-3OW5t08v.js';
import '../../chunks/bundle-CFXlbz6X.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-DPABwR4A.js';
import '../../chunks/bundle-Bsdfe5yG.js';
import '../../Message/hooks/useDirtyGetMentions.js';
import '../../ui/DateSeparator.js';
import '../../chunks/bundle-DmX77DTu.js';
import '../../ui/MessageInput.js';
import '../../chunks/bundle-DyTMSX7q.js';
import '../../chunks/bundle-CWUQ80OI.js';
import 'dompurify';
import '../../chunks/bundle-BnRVAspH.js';
import '../../chunks/bundle-ySMjorsI.js';
import '../../chunks/bundle-DxT0jQsV.js';
import '../../chunks/bundle-DsnagByW.js';
import '../../ui/MessageContent.js';
import '../../chunks/bundle-xuXUit3M.js';
import '../../ui/Loader.js';
import '../../chunks/bundle-CzzanD4i.js';
import '../../chunks/bundle-C12wpwcO.js';
import '../../chunks/bundle-YDVJPPbj.js';
import '../../ui/MessageItemReactionMenu.js';
import '../../ui/ImageRenderer.js';
import '../../ui/ReactionButton.js';
import '../../chunks/bundle-Bdc0r0vX.js';
import '../../ui/EmojiReactions.js';
import '../../ui/ReactionBadge.js';
import '../../ui/BottomSheet.js';
import '../../ui/UserListItem.js';
import '../../chunks/bundle-DGC3rWK4.js';
import '../../chunks/bundle-Dwpc_MJZ.js';
import '../../ui/MutedAvatarOverlay.js';
import '../../ui/Checkbox.js';
import '../../ui/UserProfile.js';
import '../../sendbirdSelectors.js';
import '../../ui/Tooltip.js';
import '../../ui/TooltipWrapper.js';
import '../../Message/context.js';
import '../../ui/AdminMessage.js';
import '../../ui/QuoteMessage.js';
import '../../chunks/bundle-DCjrv9Kz.js';
import '../../ui/MobileMenu.js';
import '../../ui/ThreadReplies.js';
import '../../chunks/bundle-DZw8Wfu-.js';
import '../../ui/OGMessageItemBody.js';
import '../../chunks/bundle-C5677rct.js';
import '../../ui/MentionLabel.js';
import '../../ui/LinkLabel.js';
import '../../ui/TextMessageItemBody.js';
import '../../ui/FileMessageItemBody.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-CaWp0im0.js';
import '../../ui/FileViewer.js';
import '../../chunks/bundle-DoVEdOJ0.js';
import '../../ui/VoiceMessageItemBody.js';
import '../../ui/ProgressBar.js';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../ui/PlaybackTime.js';
import '../../ui/ThumbnailMessageItemBody.js';
import '../../ui/UnknownMessageItemBody.js';
import '../../ui/TemplateMessageItemBody.js';
import '../../chunks/bundle-xG1e3S1C.js';
import '../../ui/FallbackTemplateMessageItemBody.tsx.js';
import '../../ui/LoadingTemplateMessageItemBody.tsx.js';
import '../../ui/MessageFeedbackFailedModal.js';
import '../../ui/FeedbackIconButton.js';
import '../../ui/MobileFeedbackMenu.js';
import '../../ui/MessageFeedbackModal.js';
import '../../ui/Input.js';
import '../../chunks/bundle-Db8gqi-L.js';
import '../../GroupChannel/components/SuggestedReplies.js';
import '../../chunks/bundle-CwopwRQp.js';
import '../../chunks/bundle-CD0EW-ph.js';
import '../../chunks/bundle-CunaqP3n.js';
import '../../chunks/bundle-DGskllVK.js';

var Message = function (props) {
    var _a, _b;
    var config = useSendbirdStateContext().config;
    var _c = useChannelContext(), initialized = _c.initialized, currentGroupChannel = _c.currentGroupChannel, animatedMessageId = _c.animatedMessageId, setAnimatedMessageId = _c.setAnimatedMessageId, updateMessage = _c.updateMessage, scrollToMessage = _c.scrollToMessage, replyType = _c.replyType, threadReplySelectType = _c.threadReplySelectType, isReactionEnabled = _c.isReactionEnabled, toggleReaction = _c.toggleReaction, emojiContainer = _c.emojiContainer, nicknamesMap = _c.nicknamesMap, setQuoteMessage = _c.setQuoteMessage, resendMessage = _c.resendMessage, deleteMessage = _c.deleteMessage, renderUserMentionItem = _c.renderUserMentionItem, onReplyInThread = _c.onReplyInThread, onQuoteMessageClick = _c.onQuoteMessageClick, onMessageAnimated = _c.onMessageAnimated, sendMessage = _c.sendMessage, localMessages = _c.localMessages, allMessages = _c.allMessages;
    var message = props.message;
    if (!currentGroupChannel)
        return null;
    return (React__default.createElement(MessageView, __assign({}, props, { channel: currentGroupChannel, emojiContainer: emojiContainer, editInputDisabled: !initialized || isDisabledBecauseFrozen(currentGroupChannel) || isDisabledBecauseMuted(currentGroupChannel) || !config.isOnline, shouldRenderSuggestedReplies: ((_a = config === null || config === void 0 ? void 0 : config.groupChannel) === null || _a === void 0 ? void 0 : _a.enableSuggestedReplies)
            && (((_b = config === null || config === void 0 ? void 0 : config.groupChannel) === null || _b === void 0 ? void 0 : _b.showSuggestedRepliesFor) === 'all_messages'
                ? true
                : message.messageId === allMessages[allMessages.length - 1].messageId
            // Use `allMessages[allMessages.length - 1]` instead of `currentGroupChannel.lastMessage`
            // because lastMessage is not updated when **Bot** sends messages
            )
            // the options should appear only when there's no failed or pending messages
            && (localMessages === null || localMessages === void 0 ? void 0 : localMessages.length) === 0
            && getSuggestedReplies(message).length > 0, isReactionEnabled: isReactionEnabled, replyType: replyType, threadReplySelectType: threadReplySelectType, nicknamesMap: nicknamesMap, renderUserMentionItem: renderUserMentionItem, scrollToMessage: scrollToMessage, toggleReaction: toggleReaction, setQuoteMessage: setQuoteMessage, onQuoteMessageClick: onQuoteMessageClick, onReplyInThreadClick: onReplyInThread, sendUserMessage: function (params) {
            sendMessage({
                message: params.message,
                mentionedUsers: params.mentionedUsers,
                mentionTemplate: params.mentionedMessageTemplate,
            });
        }, updateUserMessage: function (messageId, params) {
            var _a;
            updateMessage({
                messageId: messageId,
                message: (_a = params.message) !== null && _a !== void 0 ? _a : '',
                mentionedUsers: params.mentionedUsers,
                mentionTemplate: params.mentionedMessageTemplate,
            });
        }, resendMessage: resendMessage, deleteMessage: deleteMessage, animatedMessageId: animatedMessageId, setAnimatedMessageId: setAnimatedMessageId, onMessageAnimated: onMessageAnimated, renderFileViewer: function (props) { return React__default.createElement(FileViewer, __assign({}, props)); }, renderRemoveMessageModal: function (props) { return React__default.createElement(RemoveMessageModal, __assign({}, props)); } })));
};

export { Message as default };
//# sourceMappingURL=Message.js.map
